// Main execution view for completing today's tasks.
import { DndContext, DragOverlay } from '@dnd-kit/core';
import { useTasksContext } from '@/features/tasks';
import { DragOverlayContent } from '@/features/planning/components/shared/DragOverlayContent';
import { useTodayViewDnd } from '@/features/today/hooks/use-today-view-dnd';
import TodayViewContent from './TodayViewContent';

const TodayView = () => {
  const { allTasks } = useTasksContext();
  const { sensors, activeItem, onDragStart, onDragEnd, onDragCancel } =
    useTodayViewDnd(allTasks);

  return (
    <DndContext
      sensors={sensors}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onDragCancel={onDragCancel}
    >
      <TodayViewContent />
      <DragOverlay dropAnimation={null}>
        <DragOverlayContent activeItem={activeItem} />
      </DragOverlay>
    </DndContext>
  );
};

export default TodayView;
